export default "__VITE_ASSET__DYJBVur8__"